module.exports = __webpack_public_path__ + "img/10_icon_dimmed.15aad228.svg";